module.exports = __webpack_public_path__ + "res/img_demo.f29c7b775ab9a34074e110bd09489cd6.webp";